import { useState } from 'react';

import { getStyled } from './styles';

import {
  Popover,
  IconButton,
  List,
  Slider,
  useTheme,
  Grid,
} from '@mui/material';

import { VolumeUp, VolumeDown } from '@mui/icons-material';

const NotificationsVolume = ({ volume, setVolume }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsOpen(false);
  };

  const handleVolumeChange = (value) => {
    setVolume(value);
    localStorage.setItem('volume', value);
  };

  return (
    <>
      <IconButton
        style={classes.icons}
        onClick={handleClick}
        aria-label='Open Notifications'
      >
        <VolumeUp color='inherit' />
      </IconButton>
      <Popover
        disableScrollLock
        open={isOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        classes={{ paper: classes.popoverPaper }}
        onClose={handleClose}
      >
        <List dense style={classes.tabContainer}>
          <Grid container spacing={2}>
            <Grid size='auto'>
              <VolumeDown />
            </Grid>
            <Grid size='grow'>
              <Slider
                value={Number(volume)}
                aria-labelledby='continuous-slider'
                step={0.1}
                min={0}
                max={1}
                onChange={(e, value) => handleVolumeChange(value)}
              />
            </Grid>
            <Grid size='auto'>
              <VolumeUp />
            </Grid>
          </Grid>
        </List>
      </Popover>
    </>
  );
};

export default NotificationsVolume;
